import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  add(event) {
    event.preventDefault()
    const template = document.getElementById("relation-template")
    if (!template) return

    const time = new Date().getTime()
    const content = template.innerHTML.replace(/NEW_RECORD/g, time)

    const wrapper = this.element.querySelector("#relation-fields-wrapper")
    wrapper.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(".nested-fields")
    if (wrapper.querySelector("input[name*='_destroy']")) {
      wrapper.querySelector("input[name*='_destroy']").value = '1'
      wrapper.style.display = 'none'
    } else {
      wrapper.remove()
    }
  }
}
